import { render, staticRenderFns } from "./iso-categories.vue?vue&type=template&id=5a84cbea&scoped=true"
import script from "./iso-categories.vue?vue&type=script&lang=js"
export * from "./iso-categories.vue?vue&type=script&lang=js"
import style0 from "./iso-categories.vue?vue&type=style&index=0&id=5a84cbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84cbea",
  null
  
)

export default component.exports